
// SVG Icon: remove
export default { id: "terriajs-remove" };
export const id = "terriajs-remove";
export const name = "remove";
